<template>
  <div class="bg-white">
    <CoverPage />
    <div class="">
      <div class="">
        <div class="lg:px-12 md:px-12 px-4">
          <OurServices />
          <MedicalCondition />
          <div class="relative">
            <img
              src="@/assets/images/line/Vector 9.png"
              alt="lineimg"
              class="m-auto"
            />
            <div
              class="lg:flex md:flex justify-center lg:ml-0 md:ml-0 ml-12 card-mid-chip"
            >
              <div
                class="borderprimary bg-white lg:p-4 md:p-4 mob-pt-3 absolute lg:top-32 md:top-32 top-0 rounded-2xl lg:w-auto md:w-auto w-3/4 m-auto"
              >
                <div class="bgcceff2 rounded-2xl">
                  <div class="lg:flex md:flex items-center lg:p-6 md:p-6 p-4">
                    <p class="font-semibold text-black fsize20 sm-fsize14">
                      Join our community to learn more<span
                        class="lg:block md:block"
                      >
                        how you can help.</span
                      >
                    </p>
                    <div
                      class="md:pl-12 lg:pl-14 pl-0 items-center flex lg:mx-auto md:mx-auto mob-justify-center"
                    >
                      <!-- <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSdCtWfdefMnH1YR7CKXQa7zhewbh7nYxnaq4kP3rVt7Ti2MRQ/viewform"
                    target="_blank"
                    alt="link"
                    class="acharhover-s"
                  > -->
                      <base-button
                        type="primary"
                        class="py-2 px-8 text-base font-bold border-2 mt-2 md:mt-0 lg:mt-0 whitespacenowrap mx-auto md:w-auto lg:w-auto w-full"
                        @click="handleClick('register')"
                        >Sign up
                      </base-button>
                      <!-- </a
                  > -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <CaseStudies />
        </div>
        <Testimonials />
        <div class="relative lg:px-12 md:px-12 px-4">
          <img
            src="@/assets/images/line/Vector 9.png"
            alt="lineimg"
            class="m-auto"
          />
          <div
            class="lg:flex md:flex justify-center lg:ml-0 md:ml-0 ml-8 card-mid-chip lg:mt-8 md:mt-8"
          >
            <div
              class="borderprimary bg-white absolute lg:top-32 md:top-32 top-0 lg:p-4 md:p-4 mob-pt-3 rounded-2xl lg:w-auto md:w-auto w-3/4 m-auto"
            >
              <div class="bgcceff2 rounded-2xl">
                <div class="lg:flex md:flex items-center lg:p-6 md:p-6 p-4">
                  <p class="font-semibold text-black fsize20 sm-fsize14">
                    Your contribution can help us support<span
                      class="lg:block md:block"
                    >
                      a caregiver in need.</span
                    >
                  </p>
                  <div
                    class="md:pl-12 lg:pl-14 pl-0 items-center flex lg:mx-auto md:mx-auto mob-justify-center lg:pt-0 md:pt-0 pt-2"
                  >
                    <!-- <a
                  href="https://pages.razorpay.com/caregiversaathi-donation"
                  alt="link"
                  target="_blank"
                >
                </a> -->
                    <base-button
                      type="primary"
                      @click="handleClick('donation')"
                      class="py-2 px-8 text-base font-bold border-2 md:w-auto lg:w-auto w-full fsize16-14"
                      >Donate</base-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <Membership /> -->
        <!-- <Partners /> -->
      </div>

      <Partners />
      <LatestGrid />
      <div class="lg:px-12 md:px-12 px-4">
        <FAQ />
      </div>
    </div>
    <div class="bge3ceff-opa rounded-t-5555 mt-12">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<script>
import CoverPage from "./components/CoverPage.vue";
import OurServices from "./components/OurServices.vue";
import MedicalCondition from "./components/MedicalCondition.vue";
import CaseStudies from "./components/CaseStudies.vue";
import Testimonials from "./components/Testimonials.vue";
import Membership from "./components/Membership.vue";
import FAQ from "./components/FAQ.vue";
import LatestGrid from "./components/LatestGrid.vue";
import DownloadApp from "../home/components/DownloadApp.vue";
import Footer from "../Footer.vue";
import Partners from "./components/Partners.vue";
export default {
  components: {
    CoverPage,
    OurServices,
    MedicalCondition,
    CaseStudies,
    Testimonials,
    Membership,
    FAQ,
    LatestGrid,
    DownloadApp,
    Footer,
    Partners,
  },
  metaInfo: {
    title: "Care for your loved ones - Caregiver Saathi",
    meta: [
      {
        name: "keyword",
        content:
          "Caregiver caregiving, agencies for caregivers,agencies for home care,assisted home care services,home care agency,home care for elderly,home care for seniors,at home nurse care,at home senior care services,care for the caregiver program,caregiver burden,wellness,well-being,health and well-being,mental health,physical health,psychological wellbeing,caregiver needs,caregiver burnout,caregiver stress,family caregiver,caregiver companion,respite care,attendant,patient support,nursing services,caregiving services,caregiver websites,Caregiving training,Caregiver support,Caregiving for specific needs,Caregiving training near me,Caregivers for seniors,Caregiving agencies,caregiving agencies in Mumbai,Caregiving and compassionate reasons,Caregiving for healthcare professionals,counselling,therapy,coaching,caregiver coaching,palliative care,caregiving support for cancer patient,attendant for dementia patient,helpline for caregiving,grief support group,volunteering,volunteering opportunities in India,grief management,employee well-being,corporate services,online forum for caregiver,community for caregivers,bhavana Issar,online learning,care management,caregiving courses,",
      },
      {
        name: "description",
        content:
          "Want to help a friend struggling with caregiving of their chronically ill parent? Not sure how? Caregiver Saathi can guide you",
      },
    ],
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
    handleRoute(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
